import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/history/python2.png'
import _imports_1 from '@/assets/img/history/v1.png'
import _imports_2 from '@/assets/img/history/v2.png'
import _imports_3 from '@/assets/img/history/v3.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f9ca5db8")

_pushScopeId("data-v-f9ca5db8")
const _hoisted_1 = { class: "card content-card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Povijest razvoja", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Ovako je e-Dnevnik Plus izgledao krajem 2018. godine: ")
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("300 linija Python koda (ispušta i zvukove :P). Zapravo, tada aplikacija još nije niti imala naziv. Bilo je moguće navigirati razredima, predmetima, uređivati ocjene i pregledavati razrednu statistiku ocjena. Naziv sam osmislio nakon što sam završio prvu verziju proširenja za Chrome Web Trgovinu. To mi je prva web aplikacija, sa 16 godina u 2. razredu srednje škole TŠSB.")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Ovako je e-Dnevnik Plus izgledao početkom 2019. godine: ")
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Nakon podjele na Redditu i prvih 500 korisnika, Srednja.hr objavljuje ")
const _hoisted_11 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://www.srednja.hr/zbornica/srednjoskolac-iz-broda-osmislio-program-e-dnevnik-plus-predvida-prosjek-ocjena/",
  target: "_blank"
}, " članak", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(", a potom i nekoliko drugih portala. Proširenje dostiže 2500 tjedno aktivnih korisnika pred kraj školske godine. Prelazim u ETŠ Zagreb i nastavljam nadograđivati proširenje s mnoštvom novih funkcionalnosti. Od školske godine 2019./2020. e-Dnevnik više ne prikazuje prosjek ocjena i naglo se povećava potražnja za proširenjem. Početkom 2020. godine objavio sam e-Dnevnik Plus za nastavnike i ")
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://chrisross5.github.io/e-dnevnik-plus-homepage-old/skole/",
  target: "_blank"
}, "e-Dnevnik Plus za škole", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" (verzija za info-stupove).")
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Ovako je e-Dnevnik Plus izgledao školske godine 2019./2020.: ")
const _hoisted_18 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Pred početak školske godine 2020./2021., e-Dnevnik je redizajniran s novim funkcionalnostima. To znači da sam trebao izraditi gotovo sve ispočetka. ")
const _hoisted_20 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://www.youtube.com/watch?v=t_lQPHSU8T4&list=PLzgE2RyhiYODJlMcdx7AzpmclEBe0Dbeo&ab_channel=KristijanRoss",
  target: "_blank"
}, " Playlista na Youtubeu", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" sadrži obilaske kroz 4 najbitnije stare verzije proširenja. Stara naslovna stranica (s verzijama < 5.0) nalazi se ")
const _hoisted_22 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://chrisross5.github.io/e-dnevnik-plus-homepage-old/",
  target: "_blank"
}, " ovdje", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Ovako je e-Dnevnik Plus izgledao školske godine 2020./2021.: ")
const _hoisted_27 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" e-Dnevnik Plus pobjeđuje na ")
const _hoisted_29 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://informatika.azoo.hr/natjecanje/dogadjaj/614/rezultati",
  target: "_blank"
}, " državnom natjecanju iz informatike ", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" te je izabran kao najbolji rad na izložbi ")
const _hoisted_31 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://inova-croatia.com/en/product-detail/e-dnevnik-plus-2/",
  target: "_blank"
}, " INOVA", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(". Ipak, godinu dana kasnije (ljeto 2021. nakon mature) odlučujem opet izbrisati sve i započeti iznova, ali ovaj put s boljim tehnologijama. Stoga, danas postoji moja moderna verzija e-Dnevnika - Plus App, ali i jednostavna Classic verzija koja se ugrađuje u e-Dnevnik kao što je bilo i prije. ")
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" e-Dnevnik Plus 5.0 je Open Source, izrađen u Vue Frameworku s Typescriptom. Za donacije, klikni ")
const _hoisted_38 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://ednevnik.plus/donacije",
  target: "_blank"
}, " ovdje", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(". Za pregled drugih aplikacija i proširenja, vidi moj Developer Portfolio na ")
const _hoisted_40 = /*#__PURE__*/_createVNode("a", {
  class: "plus",
  href: "https://k1k1.dev/",
  target: "_blank"
}, " k1k1.dev", -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_42 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { style: {"color":"gray","font-style":"italic","text-align":"right"} }, " — Kristijan Rosandić ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _hoisted_20,
    _hoisted_21,
    _hoisted_22,
    _hoisted_23,
    _hoisted_24,
    _hoisted_25,
    _hoisted_26,
    _hoisted_27,
    _hoisted_28,
    _hoisted_29,
    _hoisted_30,
    _hoisted_31,
    _hoisted_32,
    _hoisted_33,
    _hoisted_34,
    _hoisted_35,
    _hoisted_36,
    _hoisted_37,
    _hoisted_38,
    _hoisted_39,
    _hoisted_40,
    _hoisted_41,
    _hoisted_42,
    _hoisted_43,
    _hoisted_44,
    _hoisted_45,
    _hoisted_46
  ]))
})